import React from 'react';
import { Button, SaveButton } from 'react-admin';
import DialogActions from '@material-ui/core/DialogActions';
import IconCancel from '@material-ui/icons/Cancel';

const CustomActions = ({
  handleSubmitWithRedirect,
  pristine,
  setOpenEdit = null,
  setOpenCreate = null,
  loading,
}) => (
  <DialogActions>
    <Button
      label="ra.action.cancel"
      onClick={() => (setOpenEdit ? setOpenEdit(false) : setOpenCreate(false))}
    >
      <IconCancel />
    </Button>
    {/* For "Edit" views, disable the SaveButton if the form values are pristine (values have not been edited). */}
    <SaveButton
      handleSubmitWithRedirect={handleSubmitWithRedirect}
      saving={loading}
      disabled={loading || (setOpenEdit && pristine)}
    />
  </DialogActions>
);

export default CustomActions;
